import { cn } from '../lib/utils';

type Props = {
    className?: string;
    label?: string;
};

// The rings rotate via a wrapper div, not the svg itself: WebKit won't reliably composite a
// transform-animated inline svg, so it re-tessellates the dashed stroke every frame.
export function NessoSpinner({ className, label = 'Loading' }: Props) {
    return (
        <div
            className={cn('relative flex size-24 items-center justify-center p-1', className)}
            role="status"
            aria-live="polite"
            aria-label={label}
        >
            <div className="absolute inset-1 animate-nesso-spin will-change-transform">
                <svg
                    aria-hidden="true"
                    className="size-full text-primary"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeDasharray="60 220"
                        strokeLinecap="round"
                        strokeOpacity="0.6"
                    />
                </svg>
            </div>

            <div className="absolute inset-1 animate-nesso-spin-reverse will-change-transform">
                <svg
                    aria-hidden="true"
                    className="size-full text-primary"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="50"
                        cy="50"
                        r="38"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeDasharray="50 190"
                        strokeLinecap="round"
                        strokeOpacity="0.4"
                    />
                </svg>
            </div>

            <svg
                aria-hidden="true"
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative z-10 h-auto w-[29%] text-primary-foreground dark:text-white"
            >
                <path
                    d="M12,.9c1.1.6,1.9,1.5,2.6,2.6.6,1.2.9,2.6.9,4.4v11.6h-3.2V7.9c0-1.3-.2-2.5-.7-3.5-.4-1-1.1-1.8-1.9-2.4-.8-.6-1.8-.9-2.8-.9-1.6,0-2.7.5-3.4,1.6-.7,1-1.1,2.4-1.1,4s0,2.4.3,4.2c.2,1.8.5,4.2,1,7.4,0,.4,0,.7-.3,1-.2.3-.5.4-.9.4H0s.4-11.4.4-11.4c0-1.6.5-3,1.2-4.3.7-1.2,1.7-2.2,2.8-2.8,1.2-.7,2.5-1,3.9-1s2.5.3,3.6.9Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    );
}
